import { render } from "./GenerateWalletDetails.vue?vue&type=template&id=f5ac3ff2&scoped=true&ts=true"
import script from "./GenerateWalletDetails.vue?vue&type=script&lang=ts"
export * from "./GenerateWalletDetails.vue?vue&type=script&lang=ts"

import "./GenerateWalletDetails.vue?vue&type=style&index=0&id=f5ac3ff2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ac3ff2"],['__file',"src/components/sell/GenerateWalletDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5ac3ff2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5ac3ff2', __exports__)) {
    api.reload('f5ac3ff2', __exports__)
  }
  
  module.hot.accept("./GenerateWalletDetails.vue?vue&type=template&id=f5ac3ff2&scoped=true&ts=true", () => {
    api.rerender('f5ac3ff2', render)
  })

}


export default __exports__